import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { IHeaderParams } from 'ag-grid-community';
import { BaseGridHeader } from './base-grid-header';

@Component({
  selector: 'ces-date-header',
  standalone: true,
  imports: [TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './date-header.component.html',
  styleUrl: './date-header.component.scss',
})
export class DateHeaderComponent extends BaseGridHeader {
  headerName = '';

  protected onInit(params: IHeaderParams): void {
    this.headerName = params.displayName;
  }
}
